module.exports = __webpack_public_path__ + "static/media/pizzaPolloCebollak.6c376ab4.jpeg";